import { IconButton, SxProps } from '@mui/material';

import { FC } from 'react';
import Icon24 from './icon-24';
import { useIntl } from 'react-intl';

const DialogCloseIcon = '/icons/dialog/close.svg';

interface CloseButtonProps {
  icon?: string | File;
  sx?: SxProps;
  disabled?: boolean;
  handleClick?: () => void;
}

export const CloseButton: FC<CloseButtonProps> = ({
  icon = DialogCloseIcon,
  disabled = false,
  sx,
  handleClick,
}) => {
  const intl = useIntl();

  return (
    <IconButton
      id={'close-icon'}
      aria-label={intl.formatMessage({
        id: 'images.title.close',
      })}
      disabled={disabled}
      onClick={handleClick}
      sx={{
        position: 'absolute',
        top: 12,
        left: 12,
        opacity: disabled ? 0.4 : 1,
        ...sx,
      }}
    >
      <Icon24 icon={icon} title='alt.close' />
    </IconButton>
  );
};
